<template>
  <div>
    <b-row class="toolbar-ptc">
      <b-col></b-col>
      <b-col class="text-center title">行銷活動 / 滿意度調查管理</b-col>
      <b-col>
        <div class="text-right">
          <router-link :to="{ name: 'survey_add', params: {} }" class="btn btn-normal-ptc1" tag="button"
            v-if="FunctionPermission > 1">新增問卷</router-link>
        </div>
      </b-col>
    </b-row>

    <div id="func-content">
      <!-- 列表區 -->
      <b-card class="bg-default-card mt-3 p-3">
        <b-tabs card v-model="tabIndex">

          <!-- 進行中 -->
          <b-tab title="進行中">
            <div class="table-responsive">
              <table class="table table-bordred table-striped">
                <thead>
                  <tr>
                    <th>項次</th>
                    <th>問卷ID</th>
                    <th>名稱</th>
                    <th>訂單開始時間</th>
                    <th>訂單結束時間</th>
                    <th>優先順序</th>
                    <th>異動人員</th>
                    <th>異動時間</th>
                    <th>操作</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in ongoingItems" :key="item.survey_id">
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.survey_id }}</td>
                    <td>{{ item.name }}</td>
                    <td>{{ formatDateTime(item.user_take_start_at) }}</td>
                    <td>{{ formatDateTime(item.user_take_end_at) }}</td>
                    <td>{{ item.priority }}</td>
                    <td>{{ item.updated_name }}</td>
                    <td>{{ formatDateTime(item.updated_at) }}</td>
                    <td>
                      <button v-b-tooltip.hover.top title="預覽" class="btn-circle btn-circle-ptc1 mr-1"
                        @click="previewItem(item)">
                        <span class="fa fa-search-plus"></span>
                      </button>
                      <button v-b-tooltip.hover.top title="編輯" class="btn-circle btn-circle-ptc1 mr-1"
                        @click="goEdit(item)" v-if="FunctionPermission > 1">
                        <span class="fa fa-pencil-alt"></span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-tab>

          <!-- 未開始 -->
          <b-tab title="未開始">
            <div class="table-responsive">
              <table class="table table-bordred table-striped">
                <thead>
                  <tr>
                    <th>項次</th>
                    <th>問卷ID</th>
                    <th>名稱</th>
                    <th>訂單開始時間</th>
                    <th>訂單結束時間</th>
                    <th>優先順序</th>
                    <th>異動人員</th>
                    <th>異動時間</th>
                    <th>操作</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in notStartedItems" :key="item.survey_id">
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.survey_id }}</td>
                    <td>{{ item.name }}</td>
                    <td>{{ formatDateTime(item.user_take_start_at) }}</td>
                    <td>{{ formatDateTime(item.user_take_end_at) }}</td>
                    <td>{{ item.priority }}</td>
                    <td>{{ item.updated_name }}</td>
                    <td>{{ formatDateTime(item.updated_at) }}</td>
                    <td>
                      <button v-b-tooltip.hover.top title="預覽" class="btn-circle btn-circle-ptc1 mr-1"
                        @click="previewItem(item)">
                        <span class="fa fa-search-plus"></span>
                      </button>
                      <button v-b-tooltip.hover.top title="編輯" class="btn-circle btn-circle-ptc1 mr-1"
                        @click="goEdit(item)" v-if="FunctionPermission > 1">
                        <span class="fa fa-pencil-alt"></span>
                      </button>
                      <button v-b-tooltip.hover.top title="刪除" class="btn-circle btn-circle-ptc1"
                        @click="deleteItem(item)" v-if="FunctionPermission > 1">
                        <span class="fas fa-trash-alt"></span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-tab>

          <!-- 已過期 -->
          <b-tab title="已過期">
            <div class="table-responsive">
              <table class="table table-bordred table-striped">
                <thead>
                  <tr>
                    <th>項次</th>
                    <th>問卷ID</th>
                    <th>名稱</th>
                    <th>訂單開始時間</th>
                    <th>訂單結束時間</th>
                    <th>優先順序</th>
                    <th>異動人員</th>
                    <th>異動時間</th>
                    <th>操作</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in expiredItems" :key="item.survey_id">
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.survey_id }}</td>
                    <td>{{ item.name }}</td>
                    <td>{{ formatDateTime(item.user_take_start_at) }}</td>
                    <td>{{ formatDateTime(item.user_take_end_at) }}</td>
                    <td>{{ item.priority }}</td>
                    <td>{{ item.updated_name }}</td>
                    <td>{{ formatDateTime(item.updated_at) }}</td>
                    <td>
                      <button v-b-tooltip.hover.top title="預覽" class="btn-circle btn-circle-ptc1 mr-1"
                        @click="previewItem(item)">
                        <span class="fa fa-search-plus"></span>
                      </button>
                      <button v-b-tooltip.hover.top title="編輯" class="btn-circle btn-circle-ptc1 mr-1"
                        @click="goEdit(item)" v-if="FunctionPermission > 1">
                        <span class="fa fa-pencil-alt"></span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-tab>

        </b-tabs>
      </b-card>

      <!-- 預覽 Modal -->
      <b-modal ref="mdDetail" hide-footer size="lg" :title="md_item ? md_item.name : '問卷說明'">
        <b-container fluid>
          <div class="row" v-if="md_item">
            <div class="col-lg-12">

              <!-- 介紹 -->
              <div class="row mb-2">
                <label class="col-md-3">問卷ID：</label>
                <div class="col-md-7">{{ md_item.survey_id }}</div>
              </div>
              <div class="row mb-2">
                <label class="col-md-3">問卷名稱：</label>
                <div class="col-md-7">{{ md_item.name }}</div>
              </div>

              <div class="row mb-2">
                <label class="col-md-3">問卷引言(300字限制)：</label>
                <div class="col-md-7">{{ md_item.introduction }}</div>
              </div>

              <!-- 時間相關 -->
              <div class="row mb-2">
                <label class="col-md-3">訂單取餐開始時間：</label>
                <div class="col-md-7">{{ formatDateTime(md_item.user_take_start_at) }}</div>
              </div>

              <div class="row mb-2">
                <label class="col-md-3">訂單取餐結束時間：</label>
                <div class="col-md-7">{{ formatDateTime(md_item.user_take_end_at) }}</div>
              </div>

              <!-- 獎勵 --> <!-- 2025.12之前設定，才顯示"提交 & 贈送時間" -->
              <div class="row mb-2" v-if="md_item.gift_deliver_at">
                <label class="col-md-3">
                  {{ (md_item.accept_submit_end_at && !md_item.accept_submit_end_at.startsWith('9999')) ? '提交 & 贈送時間：' :
                  '贈送時間：' }}
                </label>
                <div class="col-md-7">
                  <span v-if="md_item.accept_submit_end_at && !md_item.accept_submit_end_at.startsWith('9999')">
                    {{ md_item.accept_submit_end_at }} (問卷最後提交時間)<br />
                  </span>
                  {{ md_item.gift_deliver_at }} (人工開始贈送時間)
                </div>
              </div>

              <div class="row mb-2">
                <label class="col-md-3">獎勵：</label>
                <div class="col-md-7">
                  <span v-if="md_item.gift_certificate_code">
                    贈送券號ID：{{ md_item.gift_certificate_code }}
                  </span>
                  <span v-else-if="md_item.gift_bonus">
                    贈送點數：{{ md_item.gift_bonus }}
                  </span>
                  <span v-else>無</span>
                </div>
              </div>

              <!-- 設定 -->
              <div class="row mb-2">
                <label class="col-md-3">訂單的會員條件：</label>
                <div class="col-md-7">{{ memberGradeText(md_item.order_member_grade) }}</div>
              </div>

              <div class="row mb-2">
                <label class="col-md-3">訂單的取餐方式條件：</label>
                <div class="col-md-7">{{ takeTypeText(md_item.take_type) }}</div>
              </div>

              <div class="row mb-2">
                <label class="col-md-3">訂單的品牌條件：</label>
                <div class="col-md-7">{{ md_item.order_brand_code || '全品牌' }} (''空值代表全品牌，可填：'MWD'、'CM'、'REAL')</div>
              </div>

              <div class="row mb-2">
                <label class="col-md-3">訂單的門市條件：</label>
                <div class="col-md-7">{{ md_item.order_store_codes || '' }} </div>
              </div>

              <div class="row mb-2">
                <label class="col-md-3">訂單的商品條件：</label>
                <div class="col-md-7">{{ md_item.order_product_codes || '' }} </div>
              </div>

              <div class="row mb-2">
                <label class="col-md-3">問卷最大總發送數量：</label>
                <div class="col-md-7">
                  {{ md_item.send_amount === 0 ? '無上限' : md_item.send_amount }}
                </div>
              </div>

              <div class="row mb-2">
                <label class="col-md-3">最大的可提交人數：</label>
                <div class="col-md-7">
                  {{ md_item.accept_submit_amount === 0 ? '無上限' : md_item.accept_submit_amount }}
                </div>
              </div>

              <div class="row mb-2">
                <label class="col-md-3">會員是否僅可填單次：</label>
                <div class="col-md-7">
                  <toggle-button disabled :value="md_item.has_submit_times" :labels="{ checked: '是', unchecked: '否' }"
                    :color="{ checked: '#dc3545', unchecked: '#6c757d' }" :height="25" :width="50" :font-size="12" />
                </div>
              </div>

              <div class="row mb-2">
                <label class="col-md-3">隨機比率：</label>
                <div class="col-md-7">{{ md_item.random_rate }}</div>
              </div>

              <div class="row mb-2">
                <label class="col-md-3">優先順序：</label>
                <div class="col-md-7">{{ md_item.priority }}</div>
              </div>

              <!-- 備註 -->
              <div class="row mb-2">
                <label class="col-md-3">備註：</label>
                <div class="col-md-7">{{ md_item.memo }}</div>
              </div>

              <div class="row mb-2">
                <label class="col-md-3">異動人員：</label>
                <div class="col-md-7">{{ md_item.updated_name }}</div>
              </div>
              <div class="row mb-2">
                <label class="col-md-3">異動時間：</label>
                <div class="col-md-7">{{ formatDateTime(md_item.updated_at) }}</div>
              </div>

              <hr />

              <!-- 題目開始 -->
              <h5 class="mb-2">問卷題目</h5>

              <div v-if="md_item.questions && md_item.questions.length > 0" class="mb-3">
                <div v-for="(q, qIndex) in md_item.questions" :key="q.question_id" class="p-2 border rounded mb-3">
                  <div><strong>題目 {{ q.seq }}：</strong> {{ q.question }}</div>
                  <div class="mt-1">
                    必填：
                    <toggle-button disabled :value="q.is_required" :labels="{ checked: '是', unchecked: '否' }"
                      :color="{ checked: '#dc3545', unchecked: '#6c757d' }" :height="25" :width="50" :font-size="12" />
                  </div>

                  <div>題目類型：{{ questionTypeText(q.question_type) }}</div>
                  <div>答案類型：{{ answerTypeText(q.answer_type) }}</div>

                  <!-- 答案清單 -->
                  <div v-if="q.answer_content && q.answer_content.length > 0" class="mt-2">
                    <div v-for="ans in q.answer_content" :key="ans.id" class="ml-3">
                      - {{ ans.text }}
                    </div>
                  </div>

                </div>
              </div>

              <div v-else>
                <span class="text-muted">此問卷無題目。</span>
              </div>

            </div>
          </div>
        </b-container>
      </b-modal>

      <!-- 刪除 Modal -->
      <b-modal ref="mdDelete" hide-footer title="問卷刪除">
        <b-container fluid>
          <form>
            <div class="row mb-3">
              <label class="control-label">確定刪除問卷 {{ md_name }} ?</label>
            </div>
            <div class="float-right">
              <b-btn variant="primary" @click="delConfirm">確定</b-btn>
              <b-btn variant="secondary" @click="delCancel">取消</b-btn>
            </div>
          </form>
        </b-container>
      </b-modal>

    </div>
  </div>
</template>

<script>

import axios from 'axios'
import { API_URL } from '@/store/root.js'
import miniToastr from 'mini-toastr'
import { getFunctionPermission } from '@/js/LoginUserFunction.js'

export default {
  name: 'ListPage',
  data() {
    return {
      FunctionPermission: 0,
      tabIndex: 0,
      statusOptions: [
        { value: 1, text: '進行中' },
        { value: 0, text: '未開始' },
        { value: 2, text: '已過期' }
      ],
      items: [],
      md_item: null,
      deleteItemObj: null,
      md_name: '',
    };
  },
  created() {
    this.FunctionPermission = getFunctionPermission('F38') // 功能權限 帶入功能代碼
    if (this.FunctionPermission < 1) {
      this.$router.push({ name: 'name' })
    }

    this.getAllSurveys()
  },
  computed: {
    now() { return new Date(); },
    notStartedItems() {
      return (this.items || []).filter(item => new Date(item.user_take_start_at) > this.now);
    },
    ongoingItems() {
      return (this.items || []).filter(item => new Date(item.user_take_start_at) <= this.now && new Date(item.user_take_end_at) >= this.now);
    },
    expiredItems() {
      return (this.items || []).filter(item => new Date(item.user_take_end_at) < this.now);
    }
  },
  methods: {
    getAllSurveys() {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/marketing/surveys/list/v1', {})
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            this.items = response.data.data
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '所有問卷資料讀取異常')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '所有問卷資料讀取異常')
          console.log(error)
        })
    },
    previewItem(item) { this.md_item = item; this.$refs.mdDetail.show(); },
    deleteItem(item) {
      this.deleteItemObj = item;
      this.md_name = item.name;
      this.$refs.mdDelete.show();
    },
    async delConfirm() {
      if (this.deleteItemObj) {
        console.log('開始刪除項目:', this.deleteItemObj.survey_id);

        try {
          // 1. 等待 API 刪除操作完成
          await this.deleteSurvey();

          // 2. 刪除成功：呼叫 getAllSurveys 重新載入所有資料
          await this.getAllSurveys();

          console.log('刪除並刷新列表成功');

          // 3. 清理狀態並關閉 Modal (只需清理 deleteItemObj 和 md_name)
          this.deleteItemObj = null;
          this.md_name = '';
          this.$refs.mdDelete.hide();

        } catch (error) {
          // API 錯誤在 deleteSurvey() 中處理了，這裡只需要保證 Modal 關閉
          console.error("刪除操作最終失敗:", error);
          this.$refs.mdDelete.hide();
        }
      }
    },
    deleteSurvey() {
      this.$parent.Loading = true;
      return axios.post(API_URL + '/web/marketing/survey/delete/v1', {
        id: this.deleteItemObj.survey_id,
      })
        .then((response) => {
          this.$parent.Loading = false;
          if (response.data.result === '0000') {
            miniToastr.success('刪除成功');
            return true;
          } else if (response.data.result === '0006') {
            this.$parent.logOut(false, true);
            throw new Error("登入狀態過期");
          } else {
            miniToastr.error(response.data.message, '錯誤訊息');
            throw new Error(response.data.message);
          }
        })
        .catch((error) => {
          this.$parent.Loading = false;
          if (error.message !== "登入狀態過期") {
            miniToastr.error(error.message || '網路或伺服器錯誤', '錯誤訊息');
          }
          throw error;
        });
    },
    delCancel() {
      this.deleteItemObj = null;
      this.md_name = '';
      this.$refs.mdDelete.hide();
    },
    formatDateTime(datetime) {
      if (!datetime) return '';
      const d = new Date(datetime);
      const pad = n => String(n).padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    goEdit(item) {
      this.$router.push({ name: 'survey_edit', params: { item } })
    },
    // 題目類型轉文字
    questionTypeText(type) {
      const map = {
        1: '文字'
      }
      return map[type] || type
    },
    // 答案類型轉文字
    answerTypeText(type) {
      const map = {
        1: '單選自訂文字',
        2: '單選固定答案數字一到五 (1是非常滿意、5非常不滿意)',
        3: '多選自訂文字',
        4: '簡答300字限制'
      }
      return map[type] || type
    },

    // 會員條件轉文字
    memberGradeText(t) {
      switch (t) {
        case 1: return '全會員';
        case 2: return '僅限正式會員';
        case 3: return '僅限基本會員';
        default: return '未知會員條件';
      }
    },

    // 取餐方式轉文字
    takeTypeText(t) {
      switch (t) {
        case 1: return '內用和外帶';
        case 2: return '僅限外帶';
        case 3: return '僅限內用';
        default: return '未知取餐方式';
      }
    }
  }
};
</script>

<style scoped>
.table-borderless th,
.table-borderless td {
  border: 0 !important;
}

.btn-circle {
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/pages/marketing/survey/List.vue